module.exports = __webpack_public_path__ + "img/data-1.4915e3a3.png";